module.exports = __webpack_public_path__ + "icon.85db83b3.svg";